import axios from 'axios';
import config from '../../../../config/index';
import React from 'react';
import { Text } from 'chaser-components';
import { token } from '../../../login/duck/actions/login';

import { SET_DETAILS_USERS, SET_DETAILS_ERROR_USERS } from '../types';

const setUserDetails = data => ({
  type: SET_DETAILS_USERS,
  payload: data,
});

const buildUserList = users =>
  users.map(user => {
    const { profile } = user;
    return {
      fullName: profile.firstName ? (
        `${profile.firstName} ${profile.lastName}`
      ) : (
        <Text style={{ display: 'flex' }} color="Red">
          Missing name
        </Text>
      ),
      emailAddress: user.emails[0] ? (
        user.emails[0].address
      ) : (
        <Text style={{ display: 'flex' }} color="Red">
          Missing email
        </Text>
      ),
    };
  });

const errorFetchingUsers = error => ({
  type: SET_DETAILS_ERROR_USERS,
  error,
});

const fetchUserDetails = bundleID => dispatch =>
  axios
    .get(`${config.host}/bundles/${bundleID}/users`, {
      headers: { Authorization: `Bearer ${token()}` },
    })
    .then(({ data }) => {
      dispatch(setUserDetails(buildUserList(data)));
    })
    .catch(error => {
      dispatch(errorFetchingUsers(error));
    });

export default fetchUserDetails;
